import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
    selector: 'app-dialog-create-program',
    templateUrl: './create-program.component.html',
    styleUrls: ['./create-program.component.scss']
})
export class CreateProgramComponent {

    constructor(public dialogRef: MatDialogRef<CreateProgramComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    /**
     TODO (NR): when integration is done use service of isolate Web Compoenent: Search
     mock data is only for showcase search in Program Step Wizard
     **/

    reinsuredData = [
        {name: 'Cedant 1'},
        {name: 'Cedant 2'},
        {name: 'Cedant 3'},
        {name: 'Cedant 4'},
        {name: 'Cedant 1, Lorem Ipsum'},
        {name: 'Cedant Cedant 2'},
        {name: 'Cedant Cedant 3'},
        {name: 'Cedant 4'},
        {name: 'Cedant 5'},
        {name: 'Cedant 6'},
        {name: 'Cedant 7'},
    ];

    step = 2;

    ok() {
        this.dialogRef.close({isOk: true});
    }

    cancel() {
        this.dialogRef.close({isCancel: true});
    }

    selectStep(value) {
        this.step = value;
    }
}
